<template lang="pug">
  .garbage.organization-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1(
          v-html="title"
        ).modal__title
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            input(type="hidden" v-model="fields.parent_id")
            .modal__row
              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Реквизиты")
                  template(slot="body")
                    e-form-group(
                      name="name"
                      inputType="name"
                      label="Полное наименование"
                      :model="fields"
                      :required="true"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="short_name"
                      inputType="name"
                      label="Сокращенное наименование"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="garbage_source_category_id"
                      inputType="select"
                      label="Категория отходообразователя"
                      :model="fields"
                      tabView="tab1"
                      :options="garbageCategory"
                    )
                    e-form-group(
                      name="ogrn"
                      inputType="ogrn"
                      label="ОГРН/ОГРНИП"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="inn"
                      inputType="inn"
                      label="ИНН"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="kpp"
                      inputType="input"
                      label="КПП"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="okpo"
                      inputType="input"
                      label="ОКПО"
                      :model="fields"
                      tabView="tab1"
                      validationRule="number"
                    )
                    e-form-group(
                      v-show="hasGarbageCadastreField"
                      name="cadastr"
                      inputType="input"
                      label="Кадастровый номер"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="legal_address"
                      inputType="address"
                      label="Юридический адрес"
                      :model="fields"
                      tabView="tab1"
                      addressIdFieldName="legal_address_id"
                      :addressData="addressData"
                    )
                    e-form-group(
                      name="status_id"
                      inputType="select"
                      :required="true"
                      label="Статус объекта"
                      :model="fields"
                      tabView="tab1"
                      :options="statuses"
                    )
                    e-form-group(
                      name="close_date"
                      inputType="calendar"
                      label="Дата закрытия"
                      :model="fields"
                      tabView="tab1"
                      type="date"
                      :disabled="fields.status_id !== notActive"
                    )
                    e-form-group(
                      v-show="hasGarbageDetailField"
                      name="detail"
                      inputType="input"
                      label="Прочая информация"
                      :model="fields"
                      tabView="tab1"
                    )
              .modal__col
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Вид деятельности по ОКВЭД")
                  template(slot="body")
                    e-form-group(
                      name="code"
                      inputType="input"
                      label="ОКВЭД(номер)"
                      :model="fields.okved"
                      validateAlias="okved.code"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="okved-name"
                      inputType="input"
                      label="ОКВЭД(наименование)"
                      :model="fields.okved"
                      validateAlias="okved.name"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="business_category_id"
                      inputType="select"
                      label="Отношение к субъектам предпринимательства"
                      :model="fields"
                      tabView="tab1"
                      :options="business_categories"
                    )
                    e-form-group(
                      name="activity_description"
                      inputType="textarea"
                      label="Краткое описание деятельности"
                      :model="fields"
                      tabView="tab1"
                    )

                accordion
                  template(slot="header")
                    e-form-subtitle(text="Руководитель")
                  template(slot="body")
                    e-form-group(
                      name="head_position"
                      inputType="input"
                      label="Должность"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_name"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_phone"
                      inputType="input"
                      validationRule="phone"
                      label="Телефон"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="head_email"
                      inputType="input"
                      validationRule="email"
                      label="Email"
                      :model="fields"
                      tabView="tab1"
                    )


              .modal__col
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Местоположение")
                  template(slot="body")
                    e-location(
                      :formValidator="formValidator"
                      :model="fields"
                      name="fact_address"
                      :required="true"
                      :addressData="addressData"
                      addressIdFieldName="fact_address_id"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if="hasGarbageContactsField"
                      name="detail"
                      inputType="textarea"
                      label="Контактные данные"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      v-if="hasGarbageSiteField"
                      name="link"
                      inputType="url"
                      label="Сайт"
                      :model="fields"
                      tabView="tab1"
                    )
                accordion
                  template(slot="header")
                    e-form-subtitle(text="Ответственный за экологию")
                  template(slot="body")
                    e-form-group(
                      name="eco_position"
                      inputType="input"
                      label="Должность"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_name"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_phone"
                      inputType="input"
                      label="Телефон"
                      validationRule="phone"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="eco_email"
                      inputType="input"
                      validationRule="email"
                      label="Email"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="photoPreview"
                      inputType="simple-file-uploader"
                      label="Фотография"
                      :model="fields"
                      tabView="tab1"
                      :uploadUrl="uploadUrl"
                      @fileUploaded="fileUploaded"
                      @fileRemoved="fileRemoved"
                      :showFilePreview="true"
                    )
            msns-links(
              v-if="hasGarbageMsnsLinks && isEdit && fields.msns.length"
              :items="fields.msns"
            )
          // вкладка НОРМАТИВЫ
          .body-flex(v-show="tabView === 'tab2'")
            r-garbage-operation(
              :id="$route.params.id"
              tabView="tab2"
              :model="fields"
              ref="garbageOperation"
              @yearMeterPlans="yearMeterPlans"
            )

          // вкладка ОТХОДЫ
          .body-flex(v-if="tabView === 'tab3'")
            garbage-table(:id="fields.id" ref="garbageTable" tabView="tab3" :year_meter_plans="year_meter_plans")

          // вкладка ОПЕРАТОРЫ
          .body-flex(v-show="tabView === 'tab4'")
            operator-table(:id="fields.id" ref="operatorTable" tabView="tab4")

          // Маршруты
          .body-flex(v-if="tabView === 'routes'").routes
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")

          //Журнал изменений
          .body-flex(v-show="tabView === 'tab5'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
          //Документы
          .body-flex(v-show="tabView === 'tab6'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
import { core, garbage } from '@/api/api-endpoints'
import hasMixin from '@/mixins/has-mixin'
import textMixin from '@/mixins/text-mixin'
import garbageForm from './mixins/garbage-form'
import { REGION_CONFIG } from '@/config/regions'

export default {
  mixins: [garbageForm, hasMixin, textMixin],
  data() {
    return {
      tabView: 'tab1',
      fields: {
        status_id: '',
        business_category_id: '',
        latitude: '',
        longitude: '',
        garbage_source_type_id: this.$route.meta.type_id,
        garbage_source_category_id: '',
        tab: '',
      },
      errors: null,
    }
  },
  computed: {
    moduleId() {
      return this.moduleIds['garbage-source']
    },
    tabs() {
      let tabs = [{ tab1: 'Общие сведения' }]
      if (REGION_CONFIG.hasGarbageOperations) {
        tabs.push({ tab2: 'Нормативы' })
      }
      if (REGION_CONFIG.hasGarbageTable) {
        tabs.push({ tab3: this.garbageTableText })
      }
      if (REGION_CONFIG.hasGarbageOperator) {
        tabs.push({ tab4: 'Операторы' })
      }
      if (REGION_CONFIG.hasGarbageRoutes) {
        tabs.push({ routes: 'Маршруты' })
      }
      if (this.fields.id && REGION_CONFIG.hasChangeLog) {
        tabs.push({ tab5: 'Журнал изменений' })
      }
      if (REGION_CONFIG.hasGarbageDocuments) {
        tabs.push({ tab6: 'Документы' })
      }
      return tabs
    },
  },
  methods: {
    getBusinessCategoriesEndpoint() {
      return core.statuses({ fields: 'business_category' })
    },
    getStatusEndpoint() {
      return core.statuses({ fields: 'status' })
    },
    getDeleteUrl(id) {
      return garbage.garbageDelete(id)
    },
    getUpdateOrCreateUrl() {
      return garbage.garbageUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return garbage.garbage(route.params.id)
    },
  },
}
</script>
